function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityOperationCanceled = function SvgActivityOperationCanceled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.313,
    viewBox: "0 0 16 16.313"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M303 282a8.159 8.159 0 1 0 8 8.157 8.079 8.079 0 0 0-8-8.157Zm4.43 11.142-1.5 1.534-2.93-2.984-2.925 2.984-1.5-1.534 2.926-2.984-2.926-2.984 1.5-1.535 2.925 2.984 2.927-2.984 1.5 1.534-2.926 2.985Z",
    style: {
      fill: "#403f40",
      fillRule: "evenodd"
    },
    transform: "translate(-295 -282)"
  }));
};
export default SvgActivityOperationCanceled;